<div class="overlay text-center" *ngIf="whenShow">
    <div class="jumbotron vertical-center h-100 w-100">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden"></span>
        </div>
    </div>
</div>